<template>
    <v-container fluid>
        <div v-if="!fetchLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">
                        {{$t('modify_vehicle')}}: 
                        <span class="font-weight-bold" v-if="form && form.plate && form.usage">
                            {{ form.usage.name }} - {{form.plate.initials}} {{form.plate.number}}
                        </span>
                    </h4>
                    <p class="text-subtitle-1">{{$t("vehicle_modify_form")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <VehicleForm ref="form" v-model="form"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        {{$t('save')}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        <v-icon left>mdi-cancel</v-icon>
                        {{$t('cancel')}}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-3"/>
                    <v-skeleton-loader type="text" class="my-3"/>
                    <v-divider/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                    <v-skeleton-loader type="text" class="my-6"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="me-5"/>
                    <v-skeleton-loader type="button"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.model" v-bind="alert"/>
    </v-container>
</template>

<script>
import VehicleForm from './../../components/fleet/VehicleForm.vue';
import vehicleAPI from './../../services/fleet/vehicle';
import PAlert from './../../components/common/PAlert.vue';

export default {
    components: {
        VehicleForm,
        PAlert
    },
    data() {
        return {
            form: {},
            fetchLoading: false,
            loading: false,
            id: null,
            alert: {
                title: this.$t("alert_title"),
                content: "",
                callback: null,
                model: false
            },
        }
    },
    methods: {
        fetchVehicleAsync() {
            this.fetchLoading = true;
            vehicleAPI.get(this.id).then(response => {
                let d = response.data
                this.form = {
                    ...d,
                    plate_initials: d.plate ? d.plate.initials : null,
                    plate_number: d.plate ? d.plate.number: null,
                    plate_type: d.plate ? d.plate.type : null,
                    brand_id: d.model && d.model.brand ? d.model.brand.id : null,
                    model_id: d.model ? d.model.id : null,
                    usage_id: d.usage ? d.usage.id : null,
                    dimension_id: d.dimension ? d.dimension.id : null
                }
            }).finally(() => {
                this.fetchLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_you_want_to_save"), model: true, callback: this.save}
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            vehicleAPI.update(this.id, this.form).then(response => {
                this.$router.replace({
                    name: "VehicleDisplay",
                    params: {
                        vehicleID: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: this.$t("are_you_sure_cancel"), model: true, callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.id = this.$route.params.vehicleID;
        this.fetchVehicleAsync();
    }
}
</script>

<style>

</style>